/* eslint-env browser */
// Blatantly (with modifications) stolen from:
// https://stackoverflow.com/questions/30047056/is-it-possible-to-check-if-the-user-has-a-camera-and-microphone-and-if-the-permi

import Env from './Env';

export const MEDIADEVICE_RESULT = {
  TRUE: 'true',
  FALSE: 'false',
  UNKNOWN: 'unknown',
};

/**
 * MediaDeviceDetector - Class for detecting Microphone, Speakers, and Camera on browser
 */

class MediaDeviceDetector {
  constructor() {
    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      // Firefox 38+ seems having support of enumerateDevicesx
      navigator.enumerateDevices = (callback) => {
        navigator.mediaDevices.enumerateDevices().then(callback);
      };
    }

    this.mediaDevices = [];
    this.isHTTPs = location.protocol === 'https:'; // eslint-disable-line no-restricted-globals
    this.canEnumerate = false;

    if (
      (typeof MediaStreamTrack !== 'undefined' &&
        'getSources' in MediaStreamTrack) ||
      (navigator.mediaDevices && !!navigator.mediaDevices.enumerateDevices)
    ) {
      this.canEnumerate = true;
    }

    this.hasMicrophone = MEDIADEVICE_RESULT.UNKNOWN;
    this.hasSpeakers = MEDIADEVICE_RESULT.UNKNOWN;
    this.hasWebcam = MEDIADEVICE_RESULT.UNKNOWN;

    this.isMicrophoneAlreadyCaptured = false;
    this.isWebcamAlreadyCaptured = false;
  }

  /**
   * checkDeviceSupport - runs the device check. This call is asynchronous. hasMicrophone,
   *    hasSpeakers and hasWebcam will be "unknown" until device call completes.
   *
   * @return {type}  null
   */
  checkDeviceSupport() {
    if (!this.canEnumerate) {
      return;
    }

    if (
      !navigator.enumerateDevices &&
      window.MediaStreamTrack &&
      window.MediaStreamTrack.getSources
    ) {
      navigator.enumerateDevices = window.MediaStreamTrack.getSources.bind(window.MediaStreamTrack);
    }

    if (!navigator.enumerateDevices && navigator.enumerateDevices) {
      navigator.enumerateDevices = navigator.enumerateDevices.bind(navigator);
    }

    if (!navigator.enumerateDevices) {
      return;
    }

    this.mediaDevices = [];
    navigator.enumerateDevices((devices) => {
      devices.forEach((_device) => {
        // Make a copy of device w/o the toJSON method
        const device = {
          ..._device,
          toJSON: undefined,
        };

        if (device.kind === 'audio') {
          device.kind = 'audioinput';
        }

        if (device.kind === 'video') {
          device.kind = 'videoinput';
        }

        let skip;
        this.mediaDevices.forEach((d) => {
          if (d.id === device.id && d.kind === device.kind) {
            skip = true;
          }
        });

        if (skip) {
          return;
        }

        if (!device.deviceId) {
          device.deviceId = device.id;
        }

        if (!device.id) {
          device.id = device.deviceId;
        }

        if (!device.label) {
          if (!this.isHTTPs && Env.isDev) {
            console.warn(`HTTPs is required to get label of this ${device.kind} device.`);
          }
        } else {
          if (device.kind === 'videoinput' && !this.isWebcamAlreadyCaptured) {
            this.isWebcamAlreadyCaptured = true;
          }

          if (
            device.kind === 'audioinput' &&
            !this.isMicrophoneAlreadyCaptured
          ) {
            this.isMicrophoneAlreadyCaptured = true;
          }
        }

        if (device.kind === 'audioinput') {
          this.hasMicrophone = MEDIADEVICE_RESULT.TRUE;
        }
        if (device.kind === 'audiooutput') {
          this.hasSpeakers = MEDIADEVICE_RESULT.TRUE;
        }
        if (device.kind === 'videoinput') {
          this.hasWebcam = MEDIADEVICE_RESULT.TRUE;
        }

        this.mediaDevices.push(device);
      });
      // Camera and Microphone support is pretty good, so assume there is none if the API is supported.
      // Speaker detection is not supported on Safari, so leave it as "unknown" if not found
      if (this.hasMicrophone === MEDIADEVICE_RESULT.UNKNOWN) { this.hasMicrophone = MEDIADEVICE_RESULT.FALSE; }
      if (this.hasWebcam === MEDIADEVICE_RESULT.UNKNOWN) { this.hasWebcam = MEDIADEVICE_RESULT.FALSE; }
    });
  }
}

export default MediaDeviceDetector;
